import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_OPS_API;

const SALES_BY_COMPANY_ROUTE = `${API_URL}/statistics/by-company/:company/sales`;
const ITEM_SALES_BY_COMPANY_ROUTE = `${API_URL}/statistics/by-company/:company/item-sales`;
const ALL_ITEM_SALES_BY_COMPANY_ROUTE = `${API_URL}/statistics/by-company/:company/all-item-sales`;

export default {
  async getSalesByCompany(company, year, month, day) {
    const response = await customFetch(SALES_BY_COMPANY_ROUTE, {
      params: { company },
      query: { year, month, day },
    });

    const { payload = [], payloadNonFiscal = [] } = await response.json();

    return { payload, payloadNonFiscal };
  },

  async getItemSalesByCompany(company) {
    const response = await customFetch(ITEM_SALES_BY_COMPANY_ROUTE, {
      params: { company },
    });

    const { payload = [], payloadNonFiscal = [] } = await response.json();

    return payload.concat(payloadNonFiscal.map(entry => ({
      date: entry.date,
      items: entry.items.map(item => ({
        count: item.count,
        date: item.date,
        item: item.item.replace('undefined', ''),
      })),
    })));
  },

  async getAllItemSalesByCompany(company) {
    const response = await customFetch(ALL_ITEM_SALES_BY_COMPANY_ROUTE, {
      params: { company },
    });

    const { payload = [], payloadNonFiscal = [] } = await response.json();

    return payload.concat(payloadNonFiscal.map(item => ({
      count: item.count,
      _id: {
        // eslint-disable-next-line
        ...item['_id'],
        sku: '',
      },
    })));
  },
};
